import "./VehicleWarning.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchVehiclesDetails } from "../../../../../slices/vehiclesDetailsSlice";

const VehicleWarning = () => {
    const dispatch = useDispatch();
    const warning = useSelector((state) => state.vehiclesDetails.warning);
    const token = useSelector((state) => state.auth.token);

    return (
        <div className={"vehicle-warning"}>
            <div className={"vehicle-warning_container"}>
                <div className={"vehicle-warning_title"}>
                    {"Внимание"}
                </div>
                <div className={"vehicle-warning_note"}>
                    {warning.map((info) => (
                        <div className={"vehicle-warning_descr"}>
                            {info}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default VehicleWarning;